export const GTMCategory = 'symptom checker';
export const GTMEvents = {
  landingVisit: 'landing page visited',
  resultVisit: 'results page visited',
  ctaClicked: 'talk to a vet button clicked',
};
